import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";

/** Installation only: one summary field, one completion action. */
export default function InstallationCompletionForm({ initialValue = "", disabled, completed, onComplete }) {
  const [summary, setSummary] = useState(initialValue);
  useEffect(() => { setSummary(initialValue); }, [initialValue]);
  const submit = (event) => {
    event.preventDefault();
    const value = summary.trim();
    if (!value || disabled || completed) return;
    onComplete(value);
  };
  return (
    <section className="rounded-[14px] border border-[var(--do-border)] bg-[var(--do-bg-solid)] p-4 sm:p-5"
      data-testid="installation-completion-form">
      <h2 className="font-heading text-xl font-bold">Compte rendu d'installation</h2>
      <p className="mt-2 text-sm text-[var(--do-muted)]">
        Le client, la machine, la date et l'intervenant sont renseignés automatiquement sur le bon.
      </p>
      <form onSubmit={submit} className="mt-4 space-y-4">
        <label className="block text-sm font-semibold" htmlFor="installation-work-summary">Travaux réalisés</label>
        <textarea id="installation-work-summary" data-testid="installation-work-summary" rows={5}
          maxLength={8000} required value={summary} disabled={disabled || completed}
          placeholder="Décrivez rapidement l'installation et les essais réalisés…"
          onChange={(event) => setSummary(event.target.value)}
          className="w-full rounded-lg border border-[var(--do-border)] bg-[var(--do-bg-solid)] px-3 py-3 text-sm" />
        {!completed && (
          <Button type="submit" variant="actaPrimary" disabled={disabled || !summary.trim()}
            data-testid="installation-complete-submit">
            {disabled ? "Clôture en cours…" : "Terminer l'installation"}
          </Button>
        )}
        {completed && <p className="text-sm font-bold text-[var(--do-accent)]">Installation terminée — bon PDF généré.</p>}
      </form>
    </section>
  );
}
